import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as notificationApi from "@/api/notification.api";
import { mutationMeta } from "@/lib/query-client";

export function useNotifications(params?: { unread?: boolean; per_page?: number }) {
  return useQuery({
    queryKey: ["notifications", params],
    queryFn: () => notificationApi.listNotifications({ ...params, page: 1 }),
    staleTime: 30_000,
  });
}

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: ["notifications", "unread-count"],
    queryFn: () => notificationApi.getUnreadNotificationCount(),
    refetchInterval: 30_000,
  });
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationApi.markNotificationRead(id),
    meta: mutationMeta.silent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notificationApi.markAllNotificationsRead(),
    meta: mutationMeta.silent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
